import { render, staticRenderFns } from "./Sottotipocomponente.vue?vue&type=template&id=44cf4e6a&scoped=true&"
import script from "./Sottotipocomponente.vue?vue&type=script&lang=js&"
export * from "./Sottotipocomponente.vue?vue&type=script&lang=js&"
import style0 from "./Sottotipocomponente.vue?vue&type=style&index=0&id=44cf4e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cf4e6a",
  null
  
)

export default component.exports